// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1761h","inner":"styles_inner__3ak_f","right":"styles_right__3ZXUX","close":"styles_close__20Ii8","footer":"styles_footer__1HhD4"};